import {post} from './http'
const baseUrl = '/api/admin/kmc/spackage'

// 分页获取专题下的内容信息
export const contentMsg = v => post(`${baseUrl}/content`, v.data, v.success, v.error)
// 获取专题列表
export const getSpackageList = v => post(`${baseUrl}/list`, v.data, v.success, v.error)
// 编辑目录
export const editCatalogue = v => post(`${baseUrl}/content/editDirectoryMessage`, v.data, v.success, v.error)
// 编辑专题信息
export const editSpackageMsg = v => post(`${baseUrl}/updateSpecialtopicasset`, v.data, v.success, v.error)
// 新建专题信息
export const newSpackageMsg = v => post(`${baseUrl}/saveSpecialtopicasset`, v.data, v.success, v.error)
// 单个专题详情
export const spackageItemMsg = v => post(`${baseUrl}/getSpecialtopicasset`, v.data, v.success, v.error)
// 删除 上架 下架
export const delAndPutaway = v => post(`${baseUrl}/updtaeSpecialtopicassetByStatus`, v.data, v.success, v.error)
// 加入推荐 取消推荐
export const recommend = v => post(`${baseUrl}/updataSpecialtopicassetRecomm`, v.data, v.success, v.error)
// 专题内容专栏删除
export const deleteSpecialColumn = v => post(`${baseUrl}/updtaeSpecialtopicassetdetailByStatus`, v.data, v.success, v.error)
// 专题内容排序
export const specilaSort = v => post(`${baseUrl}/updtaeSequenceByinerid`, v.data, v.success, v.error)
// 停止更新 开始更新
export const specialUpdate = v => post(`${baseUrl}/isupdate`, v.data, v.success, v.error)
// 添加商品
export const addShop = v => post(`${baseUrl}/insertCommodity`, v.data, v.success, v.error)